import { useMemo, useContext } from 'react';
import { context }             from 'context';
import { connect }             from 'react-redux';
import { Dispatch }            from "redux";
import { ActionTypes }         from 'actions/types';
import { reducerType }         from 'reducer';

import YouTubeVideo            from './YouTubeVideo';
import ZoomMessage             from './ZoomMessage';
import Unit                    from 'pages/apps/grid/Unit';
import useStyle                from './useStyle';

import boy                     from 'images/bg_boy.png';
import { words }               from 'utils/dictionary';
import { colors }              from 'utils/colors';
import {
   contentInfoType, 
   userInfoType 
}                              from 'types';
import { DateTime }            from 'luxon';
import { DO_TEST }             from 'actions';
import { sizeStateType }       from 'reducer/types';
import { stage }               from 'utils/constants'
import { makeStyles }          from 'makeStyles';



const dev           = process.env.NODE_ENV === 'development';
const now           = DateTime.local();
const zoomCall      = DateTime.fromISO('3022-11-17');
let showZoomMessage = false;
const showYouTube   = false;

const homePageAppText = `יישומון חדש מומלץ בשברים`


if ( now.startOf('day') <= zoomCall.startOf('day') ) {
  showZoomMessage = true;
}

const useStyles = makeStyles()(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        backgroundColor: '#FFF',
        overflow:        'hidden',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
    },
    container: {
      backgroundColor: '#FFF',
      position:        'absolute',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      fontSize:        28,
      letterSpacing:   2.9,
      fontWeight:      'bold',
      transition:      'opacity 0.5s',
      textAlign:       'center',
      lineHeight:      3,
    },
    
    image: {
      position:           'fixed',
      width:              '100vw',
      left:               '0vw',
      backgroundImage:    `url(${ boy })`,
      backgroundPosition: 'left',
      backgroundRepeat:   'no-repeat',
      backgroundSize:     'contain'
    },
    button: {
      width:           280,
      height:          45,
      minHeight:       45,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: colors.primary,
      borderRadius:    '0.2em',
      color:           '#FFF',
      fontSize:         25,
      cursor:          'pointer',
      boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
      '&:hover': {
        opacity: 0.5
      }
    },
    button2: {
      width:           300,
      height:          50,
      minHeight:       50,
      fontWeight:      'bold',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      backgroundColor: colors.primary,
      borderRadius:    '0.2em',
      color:           '#FFF',
      lineHeight:      1.3,
      cursor:          'pointer',
      boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
      '&:hover': {
        opacity: 0.5
      }
    },
    zoom: {
      width:           '100%',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      flexWrap:        'wrap',
      fontSize:        16,
      marginTop:       10,
      lineHeight:      2,
    },
    homePageAppText: {
       fontSize: 22
    },
    unit: {
      height: 250,
      width:  300,
      margin: 5
    },
    cursordefault: {
      cursor: 'default'
    }
}))

type homeProps = {
  sizeState:      sizeStateType;
  userInfo:       userInfoType;
  homePageApp:    contentInfoType[];
  //guest:          boolean;
  lang:           string;
  doTest:         () => void;
}
const Home: React.FC<homeProps> = ({
  sizeState,
  userInfo,
  homePageApp,
  //guest,
  lang,
  doTest
}) => {


  const { classes } = useStyles();

  const { userIsGuest } = useContext(context);

  const handlClick = () => {
    if (dev || stage || (userInfo.userEmail === 'raphael.shalem@gmail.com')) {
       console.log('doing test')
       doTest();
    }
  }

  const showImage = useMemo(() => {
      return sizeState.size[0] > 950
  },[sizeState])

 
  const showHomepageApp = useMemo(() => {
    return !!homePageApp.length && !userIsGuest
  },[userIsGuest, homePageApp])
   

  const {containerStyle, imageStyle, userNameStyle, buttonStyle, textStyle } = useStyle(showImage, showHomepageApp, showZoomMessage);


  return (
    <div className = { classes.root } dir = "rtl">
          {
            showImage
            &&
            <div
               className = { classes.image }
               style     = { imageStyle }
               onClick   = { handlClick }
            />
          }
          <div
             className = { classes.container }
             style     = { containerStyle }
          >
              <div style = { userNameStyle }>
                <div className = { classes.cursordefault }>
                {/* { guest ? `${ words["guest"][lang] }` : userInfo.userName } */}
                   { userIsGuest ? `${ words["guest"][lang] }` : userInfo.userName }
                </div>
                <div>
                    { `${ showHomepageApp? ', ' : '' } ${ userIsGuest ? words["greetingGuest"][lang] : userInfo.plus ? words["greetingPlus"][lang] : words["greeting"][lang] }` }
                </div>
             </div>             
             { 
                showYouTube && <YouTubeVideo containerStyle = { containerStyle } /> 
             }
             <div
               className = { classes.button }
               style     = { buttonStyle }
               onClick   = { () => { 
                import("functions/navbar/navbar_click").then(func => {
                  func.navBarClick('content') 
                });
               }}
             >
               { `${ words["goToContent"][lang] }` }
             </div>
             {
               showHomepageApp &&
               <>
                <div 
                  className = { classes.homePageAppText }
                  style     = { textStyle }
                >
                  { homePageAppText }
                </div>
                <div className = { classes.unit }>
                  <Unit
                      ind         = { 0 }
                      val         = { homePageApp[0] }
                      groupUrl    = { false }
                      gridOpacity = { 1 }
                      homePageApp
                  />
                </div>
               </>
             }
             <div className = { classes.zoom }>
                { 
                   showZoomMessage && userInfo.userRole !== 'student' &&
                   <ZoomMessage 
                     classes     = { classes }
                     buttonStyle = { buttonStyle }
                     variant     = { 1 }
                     text        = { `${ words['yisumaticaChat'][lang] }` }
                     link        = { "https://chat.whatsapp.com/D58EF9PX1ai1MwZB2t5CNO" }
                     buttonText  = { `${ words['join'][lang] }` }
                   /> 
                }
             </div>
             {/* <div className = { classes.zoom }>
                { 
                   showZoomMessage && userInfo.userRole !== 'student' &&
                   <ZoomMessage 
                     classes     = { classes }
                     buttonStyle = { buttonStyle }
                     variant     = { 2 }
                     text        = { `${ words['chatWithZvi1'][lang] }` }
                     link        = { "http://wa.me/972508386502" }
                     buttonText  = { `${ words['chatWithZvi2'][lang] }` }
                   /> 
                }
             </div> */}
          </div>
    </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {
  return {
     sizeState:      reducer.size,
     homePageApp:    reducer.content.homePageApp,
     lang:           reducer.components.lang,
     userInfo:       reducer.data.userInfo,
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  doTest: () => dispatch(DO_TEST())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
